import React, { useState, useEffect } from 'react';
import { bankingAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { fmtMoney } from '../../utils/currency';
const fmt = fmtMoney;
export default function BankReconciliation() {
  const [recs, setRecs] = useState([]); const [loading, setLoading] = useState(true);
  useEffect(() => { bankingAPI.reconciliations().then(setRecs).catch(e=>toast.error(e.message)).finally(()=>setLoading(false)); }, []);
  return (
    <div>
      <div className="toolbar"><h2>Bank Reconciliation</h2></div>
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card"><div className="card-body" style={{padding:0}}>
          <table>
            <thead><tr><th>Bank Account</th><th>Statement Date</th><th className="text-right">Statement Balance</th><th className="text-right">Book Balance</th><th className="text-right">Difference</th><th>Status</th></tr></thead>
            <tbody>
              {recs.map(r => (<tr key={r.id}>
                <td>{r.account_name}</td><td>{r.statement_date}</td><td className="amount">{fmt(r.statement_balance)}</td>
                <td className="amount">{fmt(r.book_balance)}</td>
                <td className={`amount ${Math.abs(r.difference)>0.01?'text-danger':''}`}>{fmt(r.difference)}</td>
                <td><span className={`badge badge-${r.status==='Completed'?'posted':'draft'}`}>{r.status}</span></td>
              </tr>))}
              {recs.length === 0 && <tr><td colSpan={6} className="text-center text-muted" style={{padding:30}}>No reconciliations found. Start a reconciliation from the Bank Accounts page.</td></tr>}
            </tbody>
          </table>
        </div></div>
      )}
    </div>
  );
}
